
import wx from 'weixin-js-sdk'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Clocker from 'vux/src/components/clocker/index.vue'

const settings = require('../../../server/settings')
import api from '~api'
export default {
name: "onlinefee",
components: {
XHeader,Group,Selector,XInput,Toast,Actionsheet,Clocker
},
computed:{




































},
data() {
return {
title: "在线缴费",
btnFinsh: "已完成",
isNew:window.localStorage.getItem("isNew")==="2" ? false:true,
newstudent: "",
isyjs:window.localStorage.getItem('enrollType')==='1'?true:false,
yjs:window.localStorage.getItem('enrollType')==='1'?true:false,
feelist:[

],
stuinfo:{

},
payBool: false,
flowdata:[],
totalAll: 0,
moneyNum: 0,
moneySum: 0,
lowestFee: 0,
showtoast:false,
isCanEdit:false,
showJFTJ:false,
showJFQD:false,
toasttext:'',
welBool: true,
apply1:0,
item1:{},
apply2:0,
item2:{},
apply3:0,
item3:{},
apply4:0,
item4:{},
showBool: false,
arrearagelist: [],

feeYear: '',
yjfee: {},

jfBool: true,

findYear:'',
needFee:'', // 需缴金额
isFee:'', // 已缴金额
oweFee:'', // 欠费金额
check:true,
showP:window.localStorage.getItem("isNew")==="1" && window.localStorage.getItem("enrollType")==="2" ? true :false,
time: "",
menus1: {
wechatPay: "微信支付",


}
}
},
mounted(){



this.newstudent=window.localStorage.getItem("newstudent")
this.$http.post("http://yxxt.xijing.edu.cn:9088/mpmanageback/wx/pay/getPayParam",{"appid":"wxb3f0785d0cd6de69","url":"http://yxxt.xijing.edu.cn/xijng/onlinefee/"}).then(res =>{

if(res.status==200){
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.result.appId, // 必填，公众号的唯一标识
timestamp: res.data.result.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.result.nonceStr, // 必填，生成签名的随机串
signature: res.data.result.signature,// 必填，签名，见附录1
jsApiList: ['chooseWXPay']
});

}
});

api.post("/api/NewReports/findInformation", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})

api.post("/api/greenchannel/selectStuLoanMsg", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
if(res.data.msg=="null"){
this.apply2 = 0;
}else{
this.apply2 = 1;
this.item2 = res.data.msg;
}
}
})


api.post("/api/greenchannel/selectStuJdlkMsg", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
if(res.data.msg=="null"){
this.apply3 = 0;
}else{
this.apply3 = 1;
this.item3 = res.data.msg;
}
}
})

api.post("/api/greenchannel/selectStuDelayfeeMsg", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
if(res.data.msg=="null"){
this.apply1 = 0;
}else{
this.apply1 = 1;
this.item1 = res.data.msg;
}
}
})
this.getData();
},
methods:{
subtractMoney(num1,num2){
var tmp = parseFloat(num1)-parseFloat(num2);
return parseFloat(tmp)
},
finishFuc(){
this.payBool = true;
if(window.localStorage.getItem('enrollType')==='1'){
this.$msgbox('温馨提示：', "支付超时！");
}else {
this.$msgbox('温馨提示：', "支付超时，请重新选择宿舍！");
setTimeout(this.$router.push({name: 'welcome'}),"2000");
}
},
getData(){
api.post("/api/fees/open", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{

if(res.status==200){
if(res.data.allFeeMsg){
this.arrearagelist = res.data.allFeeMsg;
this.showJFTJ =true
}else {
this.showJFTJ =false
}
if(res.data.feeList.length>0){
this.feelist = res.data.feeList;
this.showJFQD =true
}else {
this.showJFQD =false
}




if(res.data.stuDorm!={} && res.data.stuDorm!=null){
this.feelist.push({
"costName": "住宿费",
"costFees": res.data.stuDorm.dormfeeprice
})
}else{

if(window.localStorage.getItem('enrollType')==='1'){

}else {
this.$msgbox('温馨提示：',"请重新选择宿舍");
setTimeout(this.$router.push({name: 'welcome'}),"2000");
}

}
this.lowestFee = res.data.lowestFee !== null ? res.data.lowestFee.lowestFee : this.lowestFee;
if(this.lowestFee < 0){
this.isCanEdit = true
}else{
this.isCanEdit = false
}
this.feeYear = res.data.findYear;

this.findYear = res.data.findYear;
this.needFee = res.data.needFee;
this.isFee = res.data.isFee;
this.oweFee = res.data.owefee;
this.moneyNum = res.data.owefee;

if(res.data.JXJ){
this.item4 = res.data.JXJ;
this.apply4 = 1;
}

if(window.localStorage.getItem('newstudent')==='true'){
if(res.data.owefee < 0){
this.jfBool = false;
}else if(res.data.owefee == 0){

if(window.localStorage.getItem("enrollType")!=='1'){

if(this.item4!=={}){
if(this.item4.isPayMoney>0 && this.item4.status=='0'){
this.getTime()
}else {
this.jfBool = false;
this.payBool = true
}
}else {
this.jfBool = false;
}
}else {
this.jfBool = false;
if(this.item4!=={}){
if(this.item4.isPayMoney>0 && this.item4.status=='0'){
this.btnFinsh='去支付'
this.getTime()
}
}
}
}else {
if(window.localStorage.getItem("enrollType")!=='1'){
this.getTime()
}
}
}else {
if(res.data.owefee < 0){
this.jfBool = false;
}else if(res.data.owefee == 0){

if(window.localStorage.getItem("enrollType")!=='1'){

if(this.item4!=={}){
if(this.item4.isPayMoney>0 && this.item4.status=='0'){
this.getTime()
}else {
this.jfBool = false;
this.payBool = true
}
}else {
this.jfBool = false;
}
}else {
this.jfBool = false;
if(this.item4!=={}){
if(this.item4.isPayMoney>0 && this.item4.status=='0'){
this.btnFinsh='去支付'
this.getTime()
}
}
}
} else {
if(window.localStorage.getItem("enrollType")!=='1'){

this.payBool = true
}
}
}



}
})
},
checkMoney(){
var numreg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
if(this.moneyNum == '' || this.moneyNum ==null){
this.toasttext = "请输入实缴金额";
this.moneyNum = this.oweFee
this.showtoast=true;
this.$vux.loading.hide();
return false;
}else if(!numreg.test(parseFloat(this.moneyNum)) || parseFloat(this.moneyNum)>this.oweFee){
this.toasttext = "请输入正确的金额";
this.moneyNum = this.oweFee
this.showtoast=true;
this.$vux.loading.hide();
return false;
}else {
if(parseFloat(this.moneyNum)<parseFloat(this.lowestFee) && this.oweFee>=parseFloat(this.lowestFee)){

this.toasttext = "缴费金额不得低于最低缴费标准：" + parseFloat(this.lowestFee) + "元";
this.moneyNum = this.oweFee
this.showtoast = true;
this.$vux.loading.hide();
return false;
}







}
return true;
},
sortParam(obj){
var paramArr = [];
for(var o in obj){
paramArr.push(o +"="+ obj[o] +"&");
}
paramArr.sort();
var str = paramArr.join(":::").replace(/:::/g, "");
return str
},
canclepay(){
api.post("/payment/payCancel", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
if(res.data.results=='1'){
if(window.localStorage.getItem('enrollType')==='1'){
this.$msgbox('温馨提示：', "您已取消该订单！");
}else {
this.$msgbox('温馨提示：', "您已取消该订单，请重新选择宿舍！");
}
this.$router.push({name: 'welcome'})
}else{
this.$msgbox('温馨提示：', "宿管系统异常，请联系管理员！");
this.$vux.loading.hide();
}
}
})

},
choosePay(){

if((this.apply1 === 1 && this.item1.applyStatus == '0') || (this.apply2 === 1 && this.item2.applyStatus == '0') || (this.apply3 === 1 && this.item3.applyStatus == '0')){

this.$msgbox('温馨提示：', "您有未处理的绿色通道审核,请耐心等待审核后操作！");
return;
}
this.showBool = true;
},
dialogonConfirm () {
var that = this;
if(this.check){
this.check=false;
var time= Date.parse(new Date());
var sign = "timestamp="+time+"&key=FDSJFIODS823590HFDISFU8923NFFDS9F39NDSF993BB83U4FDS";
sign = this.$md5(sign).toUpperCase();
const parms ={
sign,
timestamp:time
}
api.post('/commonrest/getUniqueId',parms)
.then(function (response) {
if(response.data.code===0){
that.gotopay('wechatPay',response.data.msg)
}
})
}else {
that.$msgbox('温馨提示','请勿重复选择');
}

},
dialogonConfirm1 () {
if(this.check){
this.check=false;
var that = this;
var time= Date.parse(new Date());
var sign = "timestamp="+time+"&key=FDSJFIODS823590HFDISFU8923NFFDS9F39NDSF993BB83U4FDS";
sign = this.$md5(sign).toUpperCase();
const parms ={
sign,
timestamp:time
}
api.post('/commonrest/getUniqueId',parms)
.then(function (response) {
if(response.data.code===0){
that.gotopayFinish('wechatPay',response.data.msg)
}
})
}else {
that.$msgbox('温馨提示','请勿重复选择');
}

},
toPay (msg){
var _this = this

if((_this.apply1 === 1 && _this.item1.applyStatus == '0') || (_this.apply2 === 1 && _this.item2.applyStatus == '0') || (_this.apply3 === 1 && _this.item3.applyStatus == '0')){

this.$msgbox('温馨提示：', "您有未处理的绿色通道审核,请耐心等待审核后操作！");
return;
}
if(window.localStorage.getItem("enrollType")==="1"){
api.post('/api/fees/checkCurrentChargeInfoNew',{"stuCode": window.localStorage.getItem("stuCode")})
.then(function (response) {
if(response.data.msg==="1"){
_this.$router.push({name: 'checkin'});
}else {
_this.dialogonConfirm()

}
})
}else {
_this.dialogonConfirm()

}
},
gotopay(key,msg) {
var _this = this;
if( JSON.stringify(_this.item4) !== '{}'){
if(_this.item4.isPayMoney>0 && _this.item4.status==='0'&& _this.oweFee>0){
if(key=="wechatPay"){
var obj = {
"channelPayWay":"JSAPI",

"amount":parseFloat(_this.moneyNum)*100+"",
"terminalCode":"TM20190614112332",
"device":"WEB",
"extra":
"{\"subOpenId\":\""+window.localStorage.getItem("openId")+"\"}",
"subject": _this.feeYear+"学费",
"body":_this.feeYear+"学杂费",
"stuCode":window.localStorage.getItem("stuCode"),
"stuNum":window.localStorage.getItem("stunum"),
"year": _this.feeYear,
"collection":"西京学院",
"majorId":window.localStorage.getItem("majorId"),
'orderType':"1",
'jxjMoney':_this.item4.isPayMoney+''
};
if(_this.checkMoney()){
_this.$vux.loading.show({
text: 'Loading'
})
_this.$http.post(settings.api_root+"/payment/pay",obj,{headers:{uniqueId:msg,Authorization:window.localStorage.getItem("token")}}).then(res =>{
if(res.data!=null && res.data.code != '-1'){
var params = {
"timeStamp": res.data.results.payParams.timeStamp,
"package":res.data.results.payParams.package,
"appId": "wxb3f0785d0cd6de69",
"signType": res.data.results.payParams.signType,
"nonceStr":res.data.results.payParams.nonceStr
};
var sign = _this.sortParam(params)+"key=wyyzxml88888mtdbq66666GoodSystem";
sign = _this.$md5(sign).toUpperCase();

wx.chooseWXPay({
timestamp: res.data.results.payParams.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: res.data.results.payParams.nonceStr, // 支付签名随机串，不长于 32 位
package: res.data.results.payParams.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: res.data.results.payParams.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: sign, // 支付签名
success: function (res) {

_this.$msgbox('温馨提示：', "缴费成功！");
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();


this.$router.push({name: 'checkin'});
},
cancel: function (res) {

_this.$msgbox('温馨提示：', "取消支付，缴费失败！");
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
},
error: function(res){

_this.$msgbox('温馨提示：', "缴费失败，请刷新后重试！");
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
}
});
}else{
_this.$msgbox('温馨提示：', res.data.results);
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
}
}).catch((err)=>{
_this.$msgbox('温馨提示：', '下单失败');
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
});
}
}else if(key=="zgPay"){
_this.$msgbox('温馨提示：', "该功能暂未开放！");
setTimeout(function () {
_this.check =true;
},500);
}else{
_this.$msgbox('温馨提示：', "该功能暂未开放！");
setTimeout(function () {
_this.check =true;
},500);
}
}
else if(_this.item4.isPayMoney>0 && _this.item4.status==='1'&& _this.oweFee>0){
if(key=="wechatPay"){
var obj = {
"channelPayWay":"JSAPI",

"amount":parseFloat(_this.moneyNum)*100+"",
"terminalCode":"TM20190614112332",
"device":"WEB",
"extra":
"{\"subOpenId\":\""+window.localStorage.getItem("openId")+"\"}",
"subject": _this.feeYear+"学费",
"body":_this.feeYear+"学杂费",
"stuCode":window.localStorage.getItem("stuCode"),
"stuNum":window.localStorage.getItem("stunum"),
"year": _this.feeYear,
"collection":"西京学院",
"majorId":window.localStorage.getItem("majorId"),
'orderType':"1",
'jxjMoney':'0'
};
_this.$vux.loading.show({
text: 'Loading'
})
if(_this.checkMoney()){
_this.$http.post(settings.api_root+"/payment/pay",obj,{headers:{uniqueId:msg,Authorization:window.localStorage.getItem("token")}}).then(res =>{
if(res.data!=null && res.data.code != '-1'){
var params = {
"timeStamp": res.data.results.payParams.timeStamp,
"package": res.data.results.payParams.package,
"appId": "wxb3f0785d0cd6de69",
"signType": res.data.results.payParams.signType,
"nonceStr": res.data.results.payParams.nonceStr
};
var sign = _this.sortParam(params)+"key=wyyzxml88888mtdbq66666GoodSystem";
sign = _this.$md5(sign).toUpperCase();

wx.chooseWXPay({
timestamp: res.data.results.payParams.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: res.data.results.payParams.nonceStr, // 支付签名随机串，不长于 32 位
package: res.data.results.payParams.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: res.data.results.payParams.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: sign, // 支付签名
success: function (res) {

_this.$msgbox('温馨提示：', "缴费成功！");
_this.$vux.loading.hide();
setTimeout(function () {
_this.check =true;
},500);


this.$router.push({name: 'checkin'});
},
cancel: function (res) {

_this.$msgbox('温馨提示：', "取消支付，缴费失败！");
_this.$vux.loading.hide();
setTimeout(function () {
_this.check =true;
},500);
},
error: function(res){

_this.$msgbox('温馨提示：', "缴费失败，请刷新后重试！");
_this.$vux.loading.hide();
setTimeout(function () {
_this.check =true;
},500);
}
})
}else{
_this.$msgbox('温馨提示：', res.data.results);
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
}
}).catch((err)=>{
_this.$msgbox('温馨提示：', '下单失败');
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
});
}
}else if(key=="zgPay"){
_this.$msgbox('温馨提示：', "该功能暂未开放！");
setTimeout(function () {
_this.check =true;
},500);
}else{
_this.$msgbox('温馨提示：', "该功能暂未开放！");
setTimeout(function () {
_this.check =true;
},500);
}
}
}else {
if(key=="wechatPay"){
var obj = {
"channelPayWay":"JSAPI",

"amount":parseFloat(_this.moneyNum)*100+"",
"terminalCode":"TM20190614112332",
"device":"WEB",
"extra":
"{\"subOpenId\":\""+window.localStorage.getItem("openId")+"\"}",
"subject": _this.feeYear+"学费",
"body":_this.feeYear+"学杂费",
"stuCode":window.localStorage.getItem("stuCode"),
"stuNum":window.localStorage.getItem("stunum"),
"year": _this.feeYear,
"collection":"西京学院",
"majorId":window.localStorage.getItem("majorId"),
'orderType':"1",
'jxjMoney':'0'
};
_this.$vux.loading.show({
text: 'Loading'
})
if(_this.checkMoney()){
_this.$http.post(settings.api_root+"/payment/pay",obj,{headers:{uniqueId:msg,Authorization:window.localStorage.getItem("token")}}).then(res =>{
if(res.data!=null && res.data.code != '-1'){
var params = {
"timeStamp": res.data.results.payParams.timeStamp,
"package": res.data.results.payParams.package,
"appId": "wxb3f0785d0cd6de69",
"signType": res.data.results.payParams.signType,
"nonceStr": res.data.results.payParams.nonceStr
};
var sign = _this.sortParam(params)+"key=wyyzxml88888mtdbq66666GoodSystem";
sign = _this.$md5(sign).toUpperCase();

wx.chooseWXPay({
timestamp: res.data.results.payParams.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: res.data.results.payParams.nonceStr, // 支付签名随机串，不长于 32 位
package: res.data.results.payParams.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: res.data.results.payParams.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: sign, // 支付签名
success: function (res) {

_this.$msgbox('温馨提示：', "缴费成功！");
_this.$vux.loading.hide();
setTimeout(function () {
_this.check =true;
},500);


this.$router.push({name: 'checkin'});
},
cancel: function (res) {

_this.$msgbox('温馨提示：', "取消支付，缴费失败！");
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
},
error: function(res){

_this.$msgbox('温馨提示：', "缴费失败，请刷新后重试！");
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
}
})
}else{
_this.$msgbox('温馨提示：', res.data.results);
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
}
}).catch((err)=>{
_this.$msgbox('温馨提示：', '下单失败');
setTimeout(function () {
_this.check =true;
},500);
_this.$vux.loading.hide();
});
}
}else if(key=="zgPay"){
_this.$msgbox('温馨提示：', "该功能暂未开放！");
setTimeout(function () {
_this.check =true;
},500);
}else{
_this.$msgbox('温馨提示：', "该功能暂未开放！");
setTimeout(function () {
_this.check =true;
},500);
}
}
},

gotopayFinish(key,msg){
var _this = this;
_this.$vux.loading.show({
text: 'Loading'
})
var obj = {
"channelPayWay":"JSAPI",

"amount":'0',
"terminalCode":"TM20190614112332",
"device":"WEB",
"extra":
"{\"subOpenId\":\""+window.localStorage.getItem("openId")+"\"}",
"subject": _this.feeYear+"学费",
"body":_this.feeYear+"学杂费",
"stuCode":window.localStorage.getItem("stuCode"),
"stuNum":window.localStorage.getItem("stunum"),
"year": _this.feeYear,
"collection":"西京学院",
"majorId":window.localStorage.getItem("majorId"),
'orderType':"1",
'jxjMoney':_this.item4.isPayMoney+''
};
_this.$http.post(settings.api_root+"/payment/pay",obj,{headers:{uniqueId:msg,Authorization:window.localStorage.getItem("token")}}).then(res =>{
if(res.data.code==='1'){
_this.$vux.loading.hide();

this.$router.push({name: 'checkin'});
setTimeout(function () {
_this.check =true;
},500);

}else {
_this.$msgbox('温馨提示：', "服务器异常 请稍后再试！");
setTimeout(function () {
_this.check =true;
},500);
}
});


},
gotohome(){
var _this = this;
if( JSON.stringify(_this.item4) !== '{}'){

if(_this.item4.isPayMoney>0 && _this.item4.status==='0'){
_this.dialogonConfirm1()

}else {
_this.getData1()
}
}else {
_this.getData1()
}

},
goNext () {
var _this = this;
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));
var sort = _this.$route.params.sort;
var urlname = '';
var stunum = _this.$route.params.stunum;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort>sort){
sort = flowdata[i].sort;
urlname = flowdata[i].urlname;
_this.$router.push({name: urlname,params:{sort:sort,stunum:stunum,skip:flowdata[i].skip}});
return;
}/*else{
_this.$router.push({name: 'generateform',params:{stunum:stunum}});
}*/
}
},
getData1(){
const _this = this;
api.post("/api/proces/findProcess", {"stuCode": window.localStorage.getItem("stuCode"),"enrollType": window.localStorage.getItem("enrollType")}).then( res=>{
if(res.status==200){
console.log(res)
for(var i=0;i<res.data.results.length;i++){
var item = {
"sort":res.data.results[i].processId,
"title":res.data.results[i].moduleName,
"urlname":res.data.results[i].urlName,
"skip":res.data.results[i].skip
}
if(res.data.results[i].newStatus=='0'){
item["okflag"] = false;
}else{
item["okflag"] = true;
}
if( window.localStorage.getItem('grade')==(new Date().getFullYear()).toString()){
_this.flowdata.push(item);
}else{
if(res.data.results[i].moduleName=="缴费信息" || res.data.results[i].moduleName=="缴费详情" ){
_this.flowdata.push(item);
}
}
}
const data =_this.flowdata;
const d = data.filter(item=> !item.okflag)
if(d.length>0){
const ite = d.filter(items=> items.title === '缴费信息')
console.log(ite)
if(ite.length>0){
if(ite[0].title==='缴费信息'){
api.post('/api/NewReports/addStatus',{"stuCode": window.localStorage.getItem("stuCode"),"processId":ite[0].sort})
.then(function (response) {
if(response.data.results){
_this.goNext()
}
})
}else {
_this.goNext()
}
}else {
_this.goNext()
}
}else {
_this.goNext()
}
}
})
},
next(){
var _this = this;
var sort = _this.$route.params.sort;
var stunum = _this.$route.params.stunum;
_this.$router.push({name: 'pay',params:{sort:sort,stunum:stunum}});
},
delay(){
this.$msgbox('温馨提示：', "此项申请需到校现场办理！");



},
loan(){
var _this = this;
var stunum = _this.$route.params.stunum;
_this.$router.push({name:'loan',params:{stunum:stunum}})
},
reduce(){

var _this = this;
if(window.localStorage.getItem("newstudent")==='true'){
this.$msgbox('温馨提示：', "此项申请需到校现场办理！");
}else {
var stunum = _this.$route.params.stunum;
var tmp = 0;
console.log(this.feelist)
for(var i=0;i<this.feelist.length;i++){
if(this.feelist[i].costName=="住宿费" || this.feelist[i].costName=="学费"){
tmp += parseFloat(this.feelist[i].costFees);
}
}
_this.$router.push({name:'reduce',params:{stunum:stunum,tmp:Number(tmp)-12000}})
}

},
reGet(){
this.$router.push({name: 'welcome'});
},
getTime(){

if(window.localStorage.getItem("enrollType")!=="1"){
api.post("/api/dormitoryType/queryTime", {"stuCode": window.localStorage.getItem("stuCode"),"processId":3}).then( res=>{
if(res.data>0){
this.$msgbox('温馨提示：', '请在倒计时之前进行缴费');
this.time = new Date().getTime()+ res.data*1000
}else if(res.data=='-1'){
this.isyjs=true
} else{
this.finishFuc()
}
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/onlinefee.vue